module.exports = __webpack_public_path__ + "static/media/ic_db_invest_solid.0c54a7c8.svg";